import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { ObjectsPage } from '../../ObjectsPage';

export function HubObjectsPage() {
  return (
    <AuditWrapper>
      <ObjectsPage />
    </AuditWrapper>
  );
}
